import React, { useState, useEffect, useMemo, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import '../../assets/styles/sidebar.css';
import { AuthContext } from '../../features/auth/AuthProvider'; 
import { useViewProfile } from '../../hooks/auth/profile';
import { userPermssionsStore } from '../../store/permissions.store';


import { VscGraph } from "react-icons/vsc";
import { TiGroupOutline } from "react-icons/ti";
import { CiSettings } from "react-icons/ci";
import { RiLogoutCircleLine } from "react-icons/ri";
import { TbBrandAirbnb, TbMacro, TbLayoutDistributeHorizontal } from "react-icons/tb";
import { IoCloudUploadOutline, IoPricetagsOutline } from "react-icons/io5";
import { FaCriticalRole, FaChevronDown, FaChevronRight } from "react-icons/fa";
import { LuBox } from "react-icons/lu";
import { BiCategoryAlt } from "react-icons/bi";

import sidebarLogo from '../../assets/images/lodoSidebar.png';

export default function Sidebar({ isOpen, closeSidebar }) {

  const { data: profile } = useViewProfile();

  console.log("profile data in sidebar", profile?.user?.name);

  const canView = userPermssionsStore((state) => state.canView);

  const menuItems = useMemo(() => [
    { path: '/dashboard', label: 'Dashboard' },
    { path: '/macroFamily', label: 'Macro Family', viewResource: 'macrofamily' },
    { path: '/Categories', label: 'Categories ', viewResource: 'category' },
    { path: '/industries', label: 'Industries', viewResource: 'Industries' },
    // { path: '/products', label: 'Products',
    //   hasDropdown: true,
    //   subItems: [
    //     { path: '/products/ProductList', label: 'Products List' },
    //   ]
    //  },
    { path: '/products/ProductList', label: 'Products List', viewResource: 'Product' },
    { path: '/DistributorsList', label: 'Distributors', viewResource: 'Distributors' },
    { path: '/AdminUserList', label: 'Admin Users', viewResource: 'AdminUsers' },
    { path: '/mediauploads', label: 'Multimedia Uploads', viewResource: 'MultiMedia' },
    { path: '/tags', label: 'Tags', viewResource: 'tags' },
    { path: '/roles-and-permissions', label: 'Roles & Permissions', viewResource: 'Roles & permissions' },
    // { path: '/settings', label: 'Settings' },
  ], []);

  const visibleMenuItems = useMemo(() => {
    return menuItems.filter((item) => {
      if (!item.viewResource) return true;
      return canView(item.viewResource);
    });
  }, [menuItems, canView]);

  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);

  const [activeItem, setActiveItem] = useState(location.pathname);
  const [openDropdowns, setOpenDropdowns] = useState({});

  /* ---------------- MOBILE / TOUCH DETECTION ---------------- */
  const shouldCloseSidebar = () =>
    window.innerWidth < 768 || navigator.maxTouchPoints > 0;

  const handleNavClick = (path) => {
    setActiveItem(path);
    if (shouldCloseSidebar()) {
      closeSidebar();
    }
  };

  /* ---------------- EFFECTS ---------------- */
  useEffect(() => {
    setActiveItem(location.pathname);

    // Auto open dropdown if current route is inside it
    visibleMenuItems.forEach((item) => {
      if (item.hasDropdown) {
        const match = item.subItems.some((sub) => location.pathname === sub.path);
        if (match) {
          setOpenDropdowns((prev) => ({ ...prev, [item.label]: true }));
        }
      }
    });
  }, [location.pathname, visibleMenuItems]);

  /* ---------------- HELPERS ---------------- */
  const isActive = (item) => {
    if (!activeItem || activeItem === '/') {
      return item.path === '/dashboard';
    }
    if (item.hasDropdown && item.subItems) {
      return item.subItems.some(sub => sub.path === activeItem) || activeItem === item.path;
    }
    return activeItem === item.path;
  };

  const toggleDropdown = (label) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [label]: !prev[label]
    }));
  };

  const handleLogout = () => {
    logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };

  const renderIcon = (label) => {
    switch (label) {
      case "Dashboard": return <VscGraph />;
      case "Macro Family": return <TbMacro />;
      case "Categories ": return <BiCategoryAlt />;
      case "Industries": return <TiGroupOutline />;
      case "Products List": return <LuBox />;
      case "Distributors": return <TbLayoutDistributeHorizontal />;
      case "Admin Users": return <TbBrandAirbnb />;
      case "Multimedia Uploads": return <IoCloudUploadOutline />;
      case "Tags": return <IoPricetagsOutline />;
      case "Roles & Permissions": return <FaCriticalRole />;
      case "Settings": return <CiSettings />;
      default: return null;
    }
  };

  /* ---------------- RENDER ---------------- */
  return (
    <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        <img src={sidebarLogo} alt="Sidebar Logo" />
      </div>

      <nav className="sidebar-nav">
        <ul className="sidebar-menu">
          {visibleMenuItems.map(item => (
            <li key={item.path || item.label} className={isActive(item) ? 'active' : ''}>
              {item.hasDropdown ? (
                <>
                  <a
                    href="#!"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleDropdown(item.label);
                    }}
                    className={isActive(item) ? 'active' : ''}
                  >
                    <span className={`icon ${isActive(item) ? 'active' : ''}`}>
                      {renderIcon(item.label)}
                    </span>
                    <span className={`label ${isActive(item) ? 'active' : ''}`}>
                      {item.label}
                    </span>
                    <span style={{ marginLeft: 'auto', display: 'flex' }}>
                       {openDropdowns[item.label] ? <FaChevronDown /> : <FaChevronRight />}
                    </span>
                  </a>
                  {openDropdowns[item.label] && (
                    <ul className="nested-submenu">
                      {item.subItems.map(subItem => (
                        <li key={subItem.path || subItem.label} className={location.pathname === subItem.path ? 'active' : ''}>
                          <Link
                            to={subItem.path}
                            onClick={() => handleNavClick(subItem.path)}
                          >
                           <span className="label">
                             {subItem.label}
                           </span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              ) : (
                <Link
                  to={item.path}
                  onClick={() => handleNavClick(item.path)}
                >
                  <span className={`icon ${isActive(item) ? 'active' : ''}`}>
                    {renderIcon(item.label)}
                  </span>
                  <span className={`label ${isActive(item) ? 'active' : ''}`}>
                    {item.label}
                  </span>
                </Link>
              )}
            </li>
          ))}
        </ul>
      </nav>

      <div className="bottom">
        {/* <div className="sidebar-footer-image">
          <img src={admin} alt="Admin" />
          <p>{profile?.user?.name}</p>
        </div> */}

        {/* <div className="sidebar-footer">
          <button onClick={handleLogout} className="logout-btn">
            <RiLogoutCircleLine />
            <span className="label">Logout</span>
          </button>
        </div> */}
      </div>
    </aside>
  );
}
